import React from 'react';
import { withStyles } from '@material-ui/core';
import { Heading, Content } from '../CommonComponents';
import styles from '../DynamicExtractModal.styles';
import { IFiltersSelectionProps } from '../DynamicExtractModal.properties';
import { useDEContextSelector, useDEDispatch } from 'components/RunDynamicExtract/RunDynamicExtract.context';
import FilterGrid from './FilterGrid';
import { IExtractFilterFacade } from 'api/swaggerTypes';
import AddFilterDialog from 'components/ExtractMaintenance/Fields/AddFilterDialog';
import { useRetrieveFilterField, useSetEMFiltersData, useValidateFilter } from 'api/extractMaintenance/extractMaintenanceTemplates';

const FiltersSelection = (props: IFiltersSelectionProps) => {
    const {
        classes,
        details,
        proceedToNextPanel,
        fetchFiltersData
    } = props;

    const contextDispatch = useDEDispatch();
    const WizardDetails = useDEContextSelector<'WizardDetails'>((state) => state.WizardDetails);

    const [isUpdateFilterDialogOpen, toogleUpdateFilterDialog] = React.useState(false);
    const { mutateAsync: filterMutateAsync } = useRetrieveFilterField();
    const templateId = WizardDetails?.Details?.TemplateId;

    const [filtersFormData, setFiltersFormData] = React.useState({});
    const { mutateAsync: validateFilterMutateAsync } = useValidateFilter();
    const setEMFiltersData = useSetEMFiltersData();

    React.useEffect(
        () => {
            if (fetchFiltersData?.ExtractFilters?.length <= 0) {
                proceedToNextPanel();
            } else if (fetchFiltersData?.ExtractFilters?.length > 0) {
                contextDispatch({
                    setWizardDetails: {
                        ...WizardDetails,
                        RuntimeFilters: fetchFiltersData?.ExtractFilters,
                    }
                });
            }
        },
        [fetchFiltersData]
    );

    const handleValidateFilter = React.useCallback(
        async (data: any) => {
            const response = await validateFilterMutateAsync({ ...data });
            if (response?.ExtractFilter) {
                const updatedFilters = fetchFiltersData?.ExtractFilters.map((filter) =>
                    filter.ExtractFieldId === response.ExtractFilter.inlineObject.ExtractFieldId
                        ? { ...filter, ...response.ExtractFilter.inlineObject }
                        : filter
                );

                setEMFiltersData(templateId, true, { ...fetchFiltersData, ExtractFilters: updatedFilters });
            }

            return response;
        },
        []
    );

    const handleUpdateFilter = async (data?: IExtractFilterFacade) => {
        toogleUpdateFilterDialog(true);
        const filterFormData = await filterMutateAsync(
            {
                ExtractId: data?.ExtractId,
                TemplateId: WizardDetails?.Details?.TemplateId,
                ExtractFieldId: data?.ExtractFieldId || 0,
                FilterField: data?.FilterField,
                AreaName: data?.Source
            });

        setFiltersFormData({
            ...filterFormData,
            ExtractFilter: {
                ...filterFormData?.ExtractFilter,
                FieldId: filterFormData?.ExtractFilter?.FieldId || data?.FieldId,
                inlineObject: {
                    ...filterFormData?.ExtractFilter.inlineObject,
                    FieldId: filterFormData?.ExtractFilter?.FieldId,
                    FieldDataType: filterFormData?.ExtractFilter?.inlineObject?.FieldDataType || data?.FieldDataType
                }
            }
        });
    };

    return (
        <div className={classes.contentContainer}>
            <Heading text={details.Header} />
            <Content text={details.Description} />
            <FilterGrid
                handleUpdateFilterDetails={handleUpdateFilter}
                filtersData={fetchFiltersData}
            />
            <AddFilterDialog selectedTemplateId={templateId} isFilterDialogOpen={isUpdateFilterDialogOpen} toogleFilterDialog={toogleUpdateFilterDialog} filtersFormData={filtersFormData} isInUpdateFilter={true} handleAddFilter={handleValidateFilter} />
        </div>
    );
};

export default withStyles(styles, { index: 1 })(FiltersSelection);
